/**
 * @generated SignedSource<<c2483077ab476595753366447ecc00b1>>
 * @relayHash dc798cc8cc74b72655c7a19090058c0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb

import type { ConcreteRequest } from 'relay-runtime';
export type CommentsType = "FOOTER" | "INLINE" | "%future added value";
export type SummaryType = "BLOGPOST" | "PAGE" | "%future added value";
export type useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery$variables = {
  commentsType: CommentsType;
  contentId: string;
  contentType: SummaryType;
};
export type useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery$data = {
  readonly getCommentsSummary: {
    readonly contentId: string;
    readonly language: string;
    readonly summary: string;
    readonly summaryId: string;
  } | null | undefined;
};
export type useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery = {
  response: useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery$data;
  variables: useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentsType",
        "variableName": "commentsType"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "SmartFeaturesCommentsSummary",
    "kind": "LinkedField",
    "name": "getCommentsSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "summary"
      },
      {
        "kind": "ScalarField",
        "name": "summaryId"
      },
      {
        "kind": "ScalarField",
        "name": "language"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "dc798cc8cc74b72655c7a19090058c0e",
    "id": "436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb",
    "metadata": {},
    "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
    "operationKind": "query",
    "text": "query useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
  }
};
})();

(node as any).hash = "ffce51d12c39ccd238d2cb848107c61a";

export default node;
